import request from "@/utils/request";

// 锁定小组
export function unitMemberPayCheck(data) {
  return request({
    url: "/memberPay/unitMemberPayCheck",
    method: "post",
    data,
  });
}

export function changSortNumber(data) {
  return request({
    url: "/proj/terminal/group/ranking/manual/proj",
    method: "post",
    data,
  });
}
